"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
exports.default = (field, getField) => {
    const finalGetField = function (key) {
        const field = getField(key);
        if (!field)
            throw new Error('No field component for type: ' + key);
        return field;
    };
    if (field.fieldType) {
        return finalGetField(field.fieldType);
    }
    const typeId = (0, isArray_1.default)(field.type) ? field.type[0] : field.type;
    const text = ((0, isArray_1.default)(field.type) ? `[${typeId}]` : typeId);
    return finalGetField(text);
};
//# sourceMappingURL=getFieldComponent.js.map